import { configureStore } from '@reduxjs/toolkit'
import { usersSlice } from './UsersSlice'
import { reducer as oidcReducer } from 'redux-oidc';
import { userSlice } from './UserSlice';
import { entitySlice } from './EntitySlice';
import { entitiesSlice } from './EntitiesSlice';
import { afrSlice } from './AfrSlice';
import { documentsSlice } from './DocumentsSlice';
import { addressSlice } from './AddressSlice';
import { miscSlice }  from './MiscSlice';
import { conceptSlice } from './ConceptSlice';
import { titleSlice } from './TitleSlice';
import { taxonomyConceptSlice } from './TaxonomyConceptSlice';
import { contactSlice } from './ContactSlice';
import { auditorSlice } from './AuditorSlice';
import { auditorsSlice } from './AuditorsSlice';
import { eventsSlice } from './EventsSlice';
import { afrReviewSlice } from './AfrReviewSlice';
import { accountsSlice } from './AccountsSlice';
import { validationSlice } from './ValidationSlice';
import { registrationSlice } from './RegistrationSlice';
import { reportSlice } from './ReportSlice';
import { taxonomyVersionSlice } from './TaxonomyVersionSlice';
import { taxonomyReferenceSlice } from './TaxonomyReferenceSlice';
import { taxonomyChangesSlice } from './TaxonomyChangesSlice';
import { networkSlice } from './NetworkSlice';
import { visualizationSlice } from './VisualizationSlice';
import { adHocSlice } from './AdHocSlice';
import { affiliateSlice } from './AffiliateSlice';


export const store = configureStore({

    middleware: (getDefaultMiddleware: any) => getDefaultMiddleware({
        /*TODO: redux complains about the serializability of the
         returned authenticated user data (it contains promises that
         are not serilizable.  Remove once user data is added
         to local storage.))*/
        serializableCheck: {
            ignoredActions: ['redux-oidc/USER_FOUND'],
            ignoreState: true,
        },
    }),
    reducer: {
        users: usersSlice.reducer,
        user: userSlice.reducer,
        oidcUser: oidcReducer,
        entity: entitySlice.reducer,
        entities: entitiesSlice.reducer,
        afr: afrSlice.reducer,
        misc: miscSlice.reducer,
        documents: documentsSlice.reducer,
        addresses: addressSlice.reducer,
        concept: conceptSlice.reducer,
        title: titleSlice.reducer,
        taxonomyConcept: taxonomyConceptSlice.reducer,
        contacts: contactSlice.reducer,
        auditors: auditorsSlice.reducer,
        auditor: auditorSlice.reducer,
        events: eventsSlice.reducer,
        reviews: afrReviewSlice.reducer,
        accounts: accountsSlice.reducer,
        validation: validationSlice.reducer,
        registration: registrationSlice.reducer,
        report: reportSlice.reducer,
        taxonomyVersion: taxonomyVersionSlice.reducer,
        taxonomyReference: taxonomyReferenceSlice.reducer,
        taxonomyChanges: taxonomyChangesSlice.reducer,
        network: networkSlice.reducer,
        visualization: visualizationSlice.reducer,
        adHoc: adHocSlice.reducer,
        affiliate: affiliateSlice.reducer
    },
    
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
